<template>
  <div class="user-bar-launch-icons">
    <div class="user-bar-top-level-widgets">

      <!-- Dynamic load external header component from the window object -->
      <div v-if="externalHeaderComponent" class="top-level-widget external-wrapper">
        <component v-bind:is="externalHeaderComponent.name"></component>
      </div>

      <div class="top-level-widget">
        <top-bar-notification-widget></top-bar-notification-widget>
      </div>
      <div class="top-level-widget">
        <tray-menu></tray-menu>
      </div>

      <div class="top-level-widget">
        <personalization-widget v-if="hasPersonalization"></personalization-widget>
      </div>
      <div class="top-level-widget">
        <top-level-links></top-level-links>
        <top-level-notification></top-level-notification>
      </div>
    </div>

  </div>
</template>

<script>
  import TrayMenu from './tray-menu/TrayMenu';
  import TopLevelLinks from './top-level-links/TopLevelLinks';
  import TopLevelNotification from './top-level-menu/TopLevelNotification';
  import PersonalizationWidget from './PersonalizationWidget';
  import TopBarNotificationWidget from './TopBarNotificationWidget';
  import {sessionManager} from 'vue-infra';

  export default {
    name: 'top-bar',
    data() {
      return {
        hasPersonalization: false,
        externalHeaderComponent: null,
      };
    },
    mounted() {
      if (window.externalVueComponent) {
        this.externalHeaderComponent = window.externalVueComponent;
      }
    },
    created() {
      this.hasPersonalization = sessionManager.hasPersona('customizer');
    },
    components: {
      TrayMenu,
      TopLevelLinks,
      PersonalizationWidget,
      TopBarNotificationWidget,
      TopLevelNotification,
    }
  };
</script>

<style lang='scss' scoped>
  @import "../../../assets/scss/global";
  @import "../../../assets/scss/mixins";

  .user-bar-launch-icons{
    flex-shrink: 0;
    padding-right: 27px;
  }
  .top-bar-delimiter {
    margin: 0 14px 0 0;;
    position: relative;
    width: 1px;
    height: 40px;
    @include themify {
      $header-divider: getAttr('nav-bar-header-divider', 'framework');
      @include lp-bg-image('assets/img/' + $header-divider);
    }
    content: "";
  }

  .user-bar-logo {
    border-right: 1px solid $black;
    width: 132px;
    height: 100%;
  }

  .user-bar-top-level-widgets {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .top-level-widget{
      position: relative;
      padding: 0 3px;
    }
    .v-popover {
      .trigger {
        outline: none;
      }
    }
  }

  @media(max-width: 1300px) {
    .user-bar-launch-icons{
      padding-right: 10px;
    }
    .top-bar-delimiter {
      margin: 0 10px 0 0;
    }
  }
</style>
